<template>
<div id="inspection-header">
	<div class="panel panel-default border-panel card-view inspection-panel">
		<div class="panel-body">
			<div class="table-wrap mt-10">
				<div class="table-responsive header-table">
					<table class="table mb-0">
						<tbody>
							<tr
								style="width: 100%"
								class="table-row"
							>
								<td class="name">
									<h4>{{siteName}}</h4>
								</td>						
								<td style="width: 10%">
									<span>{{$t('app.inspections.planner_user')}}</span>
								</td>						
								<td style="width: 10%">
									<span>{{inspection.planner_user.name}}</span>
								</td>						
								<td style="width: 15%">
									<span>{{$t('app.inspections.plan_date')}}</span>
								</td>						
								<td style="width: 10%">
									<span>{{ inspection.date_of_maturity | moment("YYYY-MM-DD")}}</span>
								</td>						
							</tr>
							<tr
								style="width: 100%"
								class="table-row"
							>
								<td class="name">
									<h6>{{inspection.name}}</h6>
								</td>						
								<td style="width: 10%">
									<span>{{$t('app.inspections.responsible_user')}}</span>
								</td>						
								<td style="width: 10%">
									<span>{{inspection.responsible_user.name}}</span>	
								</td>						
								<td style="width: 10%">
									<span>{{$t('app.inspections.completion_date')}}</span>	
								</td>						
								<td style="width: 10%">
									<span v-if="inspection.date_of_completion">{{inspection.date_of_completion | moment("YYYY-MM-DD")}}</span>
									<span v-else>{{ $t('app.inspections.notCompleted')}}</span>
								</td>						
							</tr>
							<tr
								style="width: 100%"
								class="table-row"
							>
								<td class="identifier name">
									<h6>{{inspection.identifier}}</h6>
								</td>
								<td class="empty"></td>				
								<td class="empty"></td>				
								<td class="empty"></td>				
								<td class="last"></td>				
							</tr>
						</tbody>
					</table>
				</div>	
			</div>
		</div>
	</div>
</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "InspectionHeader",
  components: {
	},
	props: {
		inspection: {
			Type: Object,
			requried: true,
		},
		siteName: {
			Type: String,
			requried: true,
		}
	},
  data() {
    return {
			
		};
  },
  created() {
		
  },
  computed: {
		participantList() {
			const mappedNames = this.inspection.participants.map(
        function(participant) {
          return participant.name
        }
			);
			return mappedNames.join(', ')
		},
		siteNames() {
			const sites = []
			const distinct = (value,index,self) => {
				return self.indexOf(value) === index;
			}
			this.inspection.inspections_statements.forEach(x => {
				sites.push(x.statement.site_names)
			})
			const distinctSites = sites.filter(distinct)
			return distinctSites.join(', ')
		}
  },
  methods: {
  },
  watch: {
  }
};
</script>

<style lang="scss" scoped>
#inspection-header {

	.name {
		width: 20%;
	}
	
	td {
		border: none;
		padding-top: 0 !important;
		padding-bottom: 0 !important;
	}

	.inspection-panel {
		margin-top: 15px;
		padding: 0;
	}

	.info-row {
		margin-bottom: 10px;
	}

	.info {
		font-size: 12px;
		font-weight: bold;
	}

	.info-data {
		font-size: 12px;
	}

	.sites-info {
		white-space: nowrap;
	}

	@media print {
		.panel-body {
			padding-bottom: 0px;
			padding-top: 0px;
		}
		.header-table {
			padding: 0 15px 0 15px;
			td {
				border: 1px solid #eee;
			}
			.empty {
				border-top: 1px solid #eee !important;
				border-bottom: 1px solid #eee !important;
				border-left: none !important;
				border-right: none !important;
			}

			.identifier {
				border-top: 1px solid #eee !important;
				border-bottom: 1px solid #eee !important;
				border-left: 1px solid #eee !important;
				border-right: none !important;
			}

			.name {
				width: 20% !important;
			}

			.last {
				border-top: 1px solid #eee !important;
				border-bottom: 1px solid #eee !important;
				border-right: 1px solid #eee !important;
				border-left: none !important;
			}

			th {
				border: 1px solid #eee;
			}

		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/modules/inspections/InspectionHeader.vue